<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field  
style="width: 100%;"
[appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input 
  matInput 
  [placeholder]="label ? label : 'Email'" 
  [formControl]="controlName" 
  (blur)="onBlurEvent($event)"
  />
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="!hasError() && !isValid()" color="primary" matSuffix>{{icon ? icon: 'email'}}</mat-icon>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError()" >{{ getErrorMessage() }}</mat-error>
</mat-form-field>
